const setShowGraph = payload => {
  return {
    type: "setShowGraph",
    payload
  };
};

export default setShowGraph;
